import React, { ReactNode, useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { cn } from '@/lib/utils';

type Props = {
  children: ReactNode;
  label?: string;
  className?: string;
  copyText?: string;
};

function CardField({ children, label, className, copyText }: Props) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!copyText) return;
    navigator.clipboard.writeText(copyText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <div
      className={cn(
        'rounded-xl border border-border bg-card p-3 shadow-premium',
        className
      )}
    >
      {(label || copyText) && (
        <div className="flex items-center justify-between mb-2">
          {label && (
            <p className="uppercase text-muted-foreground text-xs tracking-widest">
              {label}
            </p>
          )}
          {copyText && (
            <button
              onClick={handleCopy}
              className="ml-auto size-5 flex items-center justify-center rounded text-muted-foreground hover:text-foreground hover:bg-accent transition-colors cursor-pointer"
              aria-label="Copy to clipboard"
            >
              {copied ? (
                <Check className="size-3 text-green-500" />
              ) : (
                <Copy className="size-3" />
              )}
            </button>
          )}
        </div>
      )}
      {children}
    </div>
  );
}

export default CardField;
